module.exports = __webpack_public_path__ + "img/Abby.a1d9b18c.jpg";